import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserSessionService } from './usersession.service';
import { DataService } from './data.service';
import { UserSession } from '../models/usersession';
import * as jwtDecode from 'jwt-decode';
import * as momenttz from 'moment-timezone';
import 'rxjs/add/operator/map';
import * as CryptoJS from 'crypto-js';
import * as forge from 'node-forge';

declare var require: any;
const timezone = require('src/assets/timezones.json');

@Injectable()
export class AuthenticationService {

  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoRuUJ/00OTIh82a1EfXu
  Qp1QfPn3bQPSjt/7h3EvYceB/bCsLgofbKQ+kvwTSz0ERNKTcSB3XUvu02VMk5YK
  bkAIchEacdYFqDDnw9nACFZJn3qyJI/SF5m7JUiaf3KS2trUh+whCHBE/TzezBx+
  I+WNrOeCUdnd0XXuTIOyay9E+E//4nUZgmJ9XY/Jjb81sq1voxV6pVy1+BEel4BQ
  sBnAxNWEx9KTlpMjuHK2aqOkCNTTv5G0yefGdWcXIGdFXOhECE9b12p3Nc4OGx5d
  /LKb7m2kSeKjj1jPnjNHVDrnrzRnEcIKmDjwAL7FequkW3OYhmP/enuvYL55GTyA
  fwIDAQAB
  -----END PUBLIC KEY-----`;

  private baseUrl = environment.apiBaseUrl;
  timeZones: any[];
  pageAccess = true;
  sessionData = new UserSession();
  tokenFromUI: string = "1e2f3g4c5h7a8x9q";
  tokenFromIV: any;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    private sessionService: UserSessionService) {
    this.getTimeZones();
  }

  login(username: string, password: string,roleType : number, isLogin: boolean) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
      });

    const timeZone = this.getBrowserTimeZone();
    // const pwd = btoa(password);
    // const data = { username, password: pwd, appType : 3, timezone: timeZone };
    // this.tokenFromIV = (Math.random() + ' ').substring(2, 10) + (Math.random() + ' ').substring(2, 10);
    // if(password){
    //   let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    //   let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromIV);
    //   let encrypted = CryptoJS.AES.encrypt(
    //     JSON.stringify(password), _key, {
    //     keySize: 16,
    //     iv: _iv,
    //     mode: CryptoJS.mode.ECB,
    //     padding: CryptoJS.pad.Pkcs7
    //   });
    //   var encryptKeyIv = this.tokenFromIV + encrypted.toString();
    // }
    // const pwd = btoa(encryptKeyIv);
    var rsa = forge.pki.publicKeyFromPem(this.publicKey);
    var encryptedPassword = window.btoa(rsa.encrypt(password));
    const data = { username, password: encryptedPassword, appType : 3, timezone: timeZone, roleType: roleType, isForceLogout: isLogin };
    return this.http.post<any>(this.baseUrl + '/api/token', data, { headers })
      .map(user => {
        if (user && user.access_token) {
          this.clearCachedMenu();
          const decodedToken = jwtDecode(user.access_token);
          this.sessionData.email = decodedToken['user.email'];
          this.sessionData.mobileNumber = decodedToken['user.mobilenumber'];
          this.sessionData.authToken = user.access_token;
          this.sessionData.userId = decodedToken['user.id'];
          this.sessionData.roleId = decodedToken['user.roleid'];
          this.sessionData.roleName = decodedToken['user.rolename'];
          this.sessionData.userFullName = decodedToken['user.fullname'];
          this.sessionData.isDynamicPassword = decodedToken.referrence1 === 'True';
          this.sessionData.regionId = decodedToken['user.regionId'];
          this.sessionData.divisionId = decodedToken['user.divisionId'];
          this.sessionData.subDivisionId = decodedToken['user.subDivisionId'];
          this.sessionData.blockId = decodedToken['user.blockId'];
          this.sessionData.filterregionId = decodedToken['user.regionId'];
          this.sessionData.filterdivisionId = decodedToken['user.divisionId'];
          this.sessionData.filtersubdivisionId = decodedToken['user.subDivisionId'];
          this.sessionData.filterblockId = decodedToken['user.blockId'];
          this.sessionData.districtId = decodedToken['user.districtId'];
          this.sessionData.userDistrictId = decodedToken['user.userDistrictId'];
          this.sessionData.userBlockId = decodedToken['user.userBlockId'];
          this.sessionData.userVillageId = decodedToken['user.userVillageId'];
          this.sessionData.departmentId = decodedToken['user.departmentId'];
          this.sessionData.userGramPanjayatId = decodedToken['user.userGramPanjayatId'];
          this.sessionData.languageType = parseInt(decodedToken['user.languagetype']);
          this.sessionData.userDistrictName=decodedToken['user.userDistrictName'];
          this.sessionData.userBlockName=decodedToken['user.userBlockName']
          this.sessionService.create(this.sessionData);
        }
        return user;
      });
  }

  isAuthenticated() {
    return !!this.sessionService.userId() && !!this.sessionService.authToken();
  }

  isPageAccessAvailable(pageUrl, pageTitle) {

    const rolePages = this.sessionService.getLocalStorageWithKey('role') ? this.sessionService.getLocalStorageWithKey('role') : '[]';
    const pages = JSON.parse(rolePages);
    const paths = ['/unauthorized', '/dashboard'];
    if (pages && pages.length > 0) {
      pages.forEach(field => {
        if (field.path) {
          paths.push(field.path);
          paths.push(field.title);
        }
        if (field.submenu && field.submenu.length > 0) {
          field.submenu.forEach(field1 => {
            if (field1.path) {
              paths.push(field1.path);
              paths.push(field1.title);
              if (field1.path === '/servicehosts/1' || field1.path === '/servicehosts/2') {
                paths.push('Test');
              }
              if (field1.path === '/beneficiaries/1' || field1.path === '/beneficiaries/2') {
                paths.push('beneficiaries');
              }
              if (field1.path === '/hosters/1' || field1.path === '/hosters/2') {
                paths.push('Hosters');
              }
            }
          });
        }
      });
      this.pageAccess = (paths.indexOf(pageUrl) >= 0) || (paths.indexOf(pageTitle) >= 0) ? true : false;
    }
    return this.pageAccess;
  }

  hasRequiredPermission(permission) {
    for (let i = 0; i < permission.length; i++) {
      if (permission[i] === this.sessionService.roleId()) {
        return true;
      }
    }
    return false;
  }

  getTimeZones() {
    this.timeZones = timezone.timeZone;
  }

  getBrowserTimeZone(): string {
    const zoneName = momenttz.tz.guess();
    const temptimezone = momenttz.tz(zoneName).zoneAbbr();
    const filterZone = this.timeZones.find(i => i.abbr === temptimezone);
    if (filterZone) {
      return filterZone.value;
    }
    return '';
  }

  clearCachedMenu() {
    this.dataService.clearCache();
  }

  clearSession() {
    this.sessionService.destroy();
    this.clearCachedMenu();
  }

  logOut() {
    this.clearCachedMenu();
    this.sessionService.destroy();
  }
}
